import { render, staticRenderFns } from "./GroceryDialog.vue?vue&type=template&id=65a9b275&scoped=true"
import script from "./GroceryDialog.vue?vue&type=script&lang=js"
export * from "./GroceryDialog.vue?vue&type=script&lang=js"
import style0 from "./GroceryDialog.vue?vue&type=style&index=0&id=65a9b275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9b275",
  null
  
)

export default component.exports